import {load} from 'recaptcha-v3';

export function serializeUrl(url: string | undefined) {
  return typeof url === 'string'
    ? url
        .toLocaleLowerCase('en')
        .replace(/ç/g, 'c')
        .replace(/ğ/g, 'g')
        .replace(/ı/g, 'i')
        .replace(/ö/g, 'o')
        .replace(/ş/g, 's')
        .replace(/ü/g, 'u')
        .replace(/\s+/g, '-')
    : '';
}

export const formatPhoneNumber = (phone: string) => {
  return phone.replace(/(\d{4})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
};

export function pascalCase(str: string) {
  if (!str) return;
  return str
    .split(' ')
    .map((val) => (val.includes('I') ? val.replace('I', 'ı') : val))
    .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
    .join(' ');
}

export const isEmailValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

export function generatePassword() {
  var length = 8,
    charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
    retVal = '';
  for (var i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export async function getRecaptchaToken() {
  const recaptcha = await load('6Lf9shkqAAAAAIUMU_ZuSJckkgrvJ3TELnprUxuE');
  const token = await recaptcha.execute('validate_captcha');

  return token ?? null;
}
